var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["list-item", { opened: _vm.isOpened }] }, [
    _c(
      "div",
      { ref: "title", staticClass: "title", on: { click: _vm.openList } },
      [
        _c("span", [_vm._v(_vm._s(_vm.list.name))]),
        _c(
          "div",
          [_c("chevron-animated", { attrs: { reverse: _vm.isOpened } })],
          1
        )
      ]
    ),
    _vm.list.items && _vm.list.items.length
      ? _c(
          "div",
          { ref: "list", staticClass: "list" },
          _vm._l(_vm.list.items[0], function(item, i) {
            return _c("a", {
              key: i,
              attrs: { href: item.url },
              domProps: { textContent: _vm._s(item.name) }
            })
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }